exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dis-flex{display:flex}.quotation-btn-wrap{width:100vw;padding:4.26667vw}.quotation-btn-wrap .quotation-btn{height:12.8vw;font-family:PingFangSC-Regular;font-size:3.73333vw;text-align:center;font-weight:400;line-height:12.8vw;border-radius:1.06667vw;cursor:pointer}.quotation-btn-wrap .quotation-btn:active{opacity:0.85}.quotation-btn-wrap[data-type='float']{text-align:center;z-index:1000}.quotation-btn-wrap[data-type='float'][data-editor='false']{position:sticky;bottom:0;background-color:inherit}.quotation-btn-wrap[data-type='float'][data-editor='true']{padding-top:0}\n", ""]);

// exports
